import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalController, NavParams, NavController, PopoverController } from '@ionic/angular';
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi
import { FormBuilder } from '@angular/forms';
import { AppService } from '../../../service';
import { PrivacyDetailDialogComponent } from '../privacy-detail-dialog/privacy-detail-dialog.component';
import { PrivacyNoticeContent } from '../../configs/privacy-notice-content.config';

@Component({
  selector: 'privacy-dialog',
  templateUrl: './privacy-dialog.component.html',
  styleUrls: ['./privacy-dialog.component.scss'],
})
export class PrivacyDialogComponent implements OnInit {
  isContractor = localStorage.getItem('partyEmployee');
  markets = [];
  checkedAgreements = 0;
  agreementList = [];
  constructor(

    public router: Router,
    public modalController: ModalController,
    public translateService: TranslateService,
    private navParams: NavParams,
    public navController: NavController,
    public activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private popoverCtrl: PopoverController,
    public appService: AppService,
  ) {
    this.markets = this.navParams.get('markets');
  }

  ngOnInit() {
    this.assembleAgreementListFromMarkets();
  }

  assembleAgreementListFromMarkets(): void {
    this.markets.forEach(market => {
      this.agreementList.push(PrivacyNoticeContent[market]);
    });
  }

  selectedChange(e) {
    if (e.detail.checked) {
      this.checkedAgreements++;
    } else {
      this.checkedAgreements--;
    }
  }

  async readPrivacy(agreement) {
    const popover = await this.popoverCtrl.create({
      component: PrivacyDetailDialogComponent,
      componentProps: {
        agreement: agreement
      },
      showBackdrop: true,
      backdropDismiss: true,
    });
    popover.onDidDismiss().then((res) => {
    });
    return await popover.present();
  }

  async cancel() {
    await this.popoverCtrl.dismiss();
    this.appService.logout();
  }
  async save() {
    if(this.checkedAgreements >= this.agreementList.length){
      await this.popoverCtrl.dismiss();
    }
    
  }
}
